import _ from 'lodash';
import api from '@/api';
import { getField, updateField } from 'vuex-map-fields';

const state = () => ({
  query: {
    order_by: 'created_at',
    dir: 'asc',
    page: 1,
    user: null,
    property_type: null,
    status: null,
  },
  pagination: {
    data: [],
    current_page: 1,
    last_page: 1,
    path: null,
    per_page: 15,
    total: 0,
    from: null,
    to: null,
    first_page_url: null,
    last_page_url: null,
    next_page_url: null,
    prev_page_url: null,
  },
  property: null,
  fetching: false,
  choices: {
    order: [
      { text: 'Created At', value: 'created_at' },
      { text: 'Updated At', value: 'updated_at' },
      { text: 'Total Price', value: 'price_total' },
    ],
    property_type: [
      { text: 'Any', value: 'null' },
      { text: 'Whole property', value: 'apartment' },
      { text: 'Rooms to Rent', value: 'room' },
    ],
    status: [
      { text: 'Any', value: 'null' },
      { text: 'Published', value: 'published' },
      { text: 'Unpublished', value: 'unpublished' },
    ],
  },
});

const getters = {
  getField,
  items: (state) => _.get(state, 'pagination.data', []),
};

const actions = {
  fetch: function(context) {
    context.commit('applyFetching', true);
    const promise = api.advert.fetch(context.state.query);
    promise
      .then((response) => {
        context.commit('applyFetched', response.data);
      })
      .catch((e) => {})
      .then(() => {
        context.commit('applyFetching', false);
      });

    return promise;
  },
  show: function(context, uuid) {
    context.commit('applyFetching', true);
    const promise = api.advert.show(uuid);
    promise
      .then((response) => {
        context.commit('applyFetchedSingle', response.data);
      })
      .catch((e) => {})
      .then(() => {
        context.commit('applyFetching', false);
      });

    return promise;
  },
  publish: function(context, uuid) {
    context.commit('applyFetching', true);
    const promise = api.advert.publish(uuid);
    promise
      .then((response) => {
        // context.commit('applyFetchedSingle', response.data);
      })
      .catch((e) => {})
      .then(() => {
        context.commit('applyFetching', false);
      });

    return promise;
  },
  unpublish: function(context, uuid) {
    context.commit('applyFetching', true);
    const promise = api.advert.unpublish(uuid);
    promise
      .then((response) => {
        // context.commit('applyFetchedSingle', response.data);
      })
      .catch((e) => {})
      .then(() => {
        context.commit('applyFetching', false);
      });

    return promise;
  },
  clear: function(context, uuid) {
    context.commit('applyClear');
  },
  delete: function(context, uuid) {
    context.commit('applyFetching', true);
    const promise = api.advert.delete(uuid);
    promise
      .then((response) => {})
      .catch((e) => {})
      .then(() => {
        context.commit('applyFetching', false);
      });

    return promise;
  },
  // cancel: function(context) {
  //   context.commit('instance/applyResetInstance', false);
  // },
};

const mutations = {
  updateField,

  applyFetching: function(state, status) {
    state.fetching = status;
  },
  applyFetched: function(state, data) {
    state.pagination = data;
  },
  applyFetchedSingle: function(state, property) {
    state.property = property;
  },
  applyClear: function(state) {
    state.property = null;
  },
};

const modules = {
  // instance: instance,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules,
};
